import React, { useState, useEffect } from 'react';
import './App.css';
import Header from './components/Header';
import Main from './components/Main';
import Footer from './components/Footer';

function App() {
  const [currentPage, setCurrentPage] = useState('welcome');

  useEffect(() => {
    // Extract page from URL hash
    const handleHashChange = () => {
      const hash = window.location.hash.substring(1);
      if (hash) {
        setCurrentPage(hash);
      } else {
        setCurrentPage('welcome');
      }
    };

    window.addEventListener('hashchange', handleHashChange);
    handleHashChange(); // Initial call

    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  return (
    <div className="App">
      <Header />
      <Main currentPage={currentPage} />
      <Footer />
    </div>
  );
}

export default App;